import { BodyType, FuelTypeHarmonized, VehicleClass } from '../../types/one-search/queries';

export function filterVehicleClasses(value: string): VehicleClass[] {
  const validClasses: VehicleClass[] = [
    'A',
    'AMGGT',
    'B',
    'C',
    'CITAN',
    'CL',
    'CLA',
    'CLC',
    'CLE',
    'CLK',
    'CLS',
    'E',
    'EQA',
    'EQB',
    'EQC',
    'EQE',
    'EQS',
    'EQT',
    'EQV',
    'G',
    'GL',
    'GLA',
    'GLB',
    'GLC',
    'GLE',
    'GLK',
    'GLS',
    'GT',
    'M',
    'MARCOPOLO',
    'MAYBACH',
    'ML',
    'R',
    'S',
    'SL',
    'SLC',
    'SLK',
    'SLR',
    'SLS',
    'SPRINTER',
    'T',
    'V',
    'VITO',
    'W',
  ];

  return value
    .split(',')
    .map((item) => item.trim())
    .filter((item): item is VehicleClass => validClasses.includes(item as VehicleClass));
}

export function filterBodyTypes(value: string): BodyType[] {
  const validBodyTypes: BodyType[] = [
    'ACTIVITY',
    'ALL_TERRAIN',
    'CABRIO',
    'CABRIO_ROADSTER',
    'CHASSIS',
    'CHASSIS_CREW_CAB',
    'COMPACT',
    'COUPE',
    'HATCHBACK',
    'HORIZON',
    'LIMOUSINE',
    'LONG_SEDAN',
    'MARCO_POLO',
    'MIXTO',
    'OFF_ROADER',
    'PANEL_VAN',
    'PEOPLE_CARRIER',
    'PICKUP',
    'PLATFORM',
    'PLATFORM_CREW_CAB',
    'ROADSTER',
    'SHOOTING_BRAKE',
    'SPORTS_TOURER',
    'STATION',
    'SUV',
    'TOURER',
    'VAN',
  ];

  return value
    .split(',')
    .map((item) => item.trim())
    .filter((item): item is BodyType => validBodyTypes.includes(item as BodyType));
}

export function filterFuelTypeHarmonized(value: string): FuelTypeHarmonized[] {
  const validFuelTypes: FuelTypeHarmonized[] = [
    'DIESEL',
    'DIESEL_ELECTRIC_PLUGIN_HYBRID',
    'ELECTRIC',
    'GAS',
    'PETROL',
    'PETROL_ELECTRIC_PLUGIN_HYBRID',
  ];

  return value
    .split(',')
    .map((item) => item.trim())
    .filter((item): item is FuelTypeHarmonized => validFuelTypes.includes(item as FuelTypeHarmonized));
}
